import React from 'react';
import { useField, useFormikContext } from 'formik';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from 'components/shadcn/ui/select';
import { Label } from 'components/shadcn/ui/label';
import { cn } from 'components/shadcn/lib/utils';
import { useUsersList } from 'components/Users/service';

export default function CompanyDropdown({ label }) {
    const [field, meta] = useField('company');
    const { setFieldValue, setFieldTouched } = useFormikContext();
    const errorOnSubmit = meta.error && meta.touched;
    const { data: companies } = useUsersList('companies', 100);

    const handleValueChange = (value) => {
        const selectedCompany = companies?.items?.find(
            (company) => company.Name === value
        );
        if (selectedCompany) {
            setFieldValue('company', selectedCompany, false);
            setFieldTouched(field.name, true, false);
        }
    };

    return (
        <div className="w-full space-y-1">
            {label && (
                <Label
                    htmlFor="company"
                    className={errorOnSubmit && 'text-red-500'}
                >
                    {label}
                </Label>
            )}
            <Select
                value={field.value?.Name ?? ''}
                onValueChange={handleValueChange}
            >
                <SelectTrigger
                    className={cn(
                        'text-red text-foreground data-[placeholder]:text-secondary-foreground',
                        errorOnSubmit && 'border-red-500'
                    )}
                >
                    <SelectValue placeholder="Select a company" />
                </SelectTrigger>
                <SelectContent>
                    {companies?.items?.map((company, index) => (
                        <SelectItem
                            key={company?.ID}
                            value={company?.Name}
                            className="cursor-pointer text-foreground focus:bg-slate-100"
                        >
                            {company?.Name}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
